var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('Particles',{attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":{
        fpsLimit: 120,
        interactivity: {
            events: {
                onClick: {
                    enable: true,
                    mode: 'push'
                },
                onHover: {
                    enable: true,
                    mode: 'repulse'
                },
                resize: true
            },
            modes: {
                bubble: {
                    distance: 400,
                    duration: 1,
                    opacity: 0.8,
                    size: 40
                },
                push: {
                    quantity: 4
                },
                repulse: {
                    distance: 200,
                    duration: 1
                }
            }
        },
        particles: {
            color: {
                value: '#ffffff'
            },
            links: {
                color: '#ffffff',
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1
            },
            collisions: {
                enable: true
            },
            move: {
                direction: 'none',
                enable: true,
                outMode: 'bounce',
                random: false,
                speed: 1,
                straight: false
            },
            number: {
                density: {
                    enable: true,
                    area: 800
                },
                value: 80
            },
            opacity: {
                value: 0.5
            },
            shape: {
                type: 'circle'
            },
            size: {
                random: true,
                value: 5
            }
        },
        detectRetina: true
    }}}),_c('img',{staticClass:"bg",attrs:{"src":require('/public/assets/bg.jpg')}}),_c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"form"}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('../assets/logo.png')}})]),_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('setProfile.label')))]),(_vm.errors.profile.show)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.errors.profile.msg)+" ")]):_vm._e(),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitProfile.apply(null, arguments)}}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v(_vm._s(_vm.$t('setProfile.firstName'))+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.firstName),expression:"profile.firstName"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName"},domProps:{"value":(_vm.profile.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "firstName", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v(_vm._s(_vm.$t('setProfile.lastName'))+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.lastName),expression:"profile.lastName"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName","placeholder":""},domProps:{"value":(_vm.profile.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "lastName", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-main",attrs:{"id":"saveBtn"}},[_vm._v(_vm._s(_vm.$t('login.submit')))])])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }